import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const BasketInfoSkeleton = () => {
  return <SkeletonBlock $width="100%" $height="120px" />;
};
